import styled from 'styled-components/macro';
import { getItemAnimation } from 'styles/animations.styled';

export const Wrapper = styled.div<{ isCollapsed: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  transition: all 400ms ease-out;
`;

export const Item = styled.div<{
  isSelected: boolean;
  isCollapsed: boolean;
  canCollapsed: boolean;
  isDisabled?: boolean;
}>`
  animation-name: ${(props) => getItemAnimation(props.isCollapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  display: ${(props) => (props.isCollapsed && !props.isSelected ? 'none' : '')};
  padding: 12px;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      (props.isCollapsed || !props.canCollapsed) && props.isSelected
        ? '#697180'
        : 'transparent'};
  box-shadow: 0 1px 2px 0 rgba(15, 23, 40, 0.04),
    0 1px 3px 0 rgba(15, 23, 40, 0.12), 0 0 8px 4px rgba(15, 23, 40, 0.04);
  background-color: ${(props) =>
    props.isDisabled
      ? '#F2F5F8'
      : props.isSelected && !props.isCollapsed && props.canCollapsed
      ? '#f2f5f8'
      : '#ffffff'};
  color: ${(props) => (props.isDisabled ? '#98A3B4' : '#1f2939')};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: ${(props) => (props.isCollapsed ? 'default' : 'pointer')};
  transition: all 150ms;

  :hover {
    background-color: ${(props) => (props.isCollapsed ? '' : '#f2f5f8')};
  }
`;

export const StyledSpan = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ToggleWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: -35px;
`;
